import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        // private loadingSpinner: LoadingSpinnerService,
        // private errorService: ErrorService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const req = request.clone({
            withCredentials: true,
            // setHeaders: {
            //     Authorization: authToken
            // }
        });

        // let ok: string;

        return next.handle(req).pipe(
            tap(
                // event => ok = event instanceof HttpResponse ? 'succeeded' : '',
                // error => ok = 'failed'
                event => {},
                error => {
                    if (error instanceof HttpErrorResponse) {
                        if (error.status === 401) {
                            this.router.navigate(['/']);
                        }
                    }
                }
            ),
        );


        // return next.handle(req).do((event: HttpEvent<any>) => {
        //     if (event instanceof HttpResponse) {
        //         let jwtToken = event.headers.get("Authorization");
        //         localStorage.setItem('id_token', jwtToken);
        //     }
        // }, (err: any) => {
        //     if (err instanceof HttpErrorResponse) {
        //         if (err.status === 401) {
        //             this.router.navigate(['/']);
        //         } else {
        //             this.errorService.setError(err.error);
        //         }
        //     }
        // }).finally(() => {
        //     this.loadingSpinner.hide();
        // });
    }
}
